export default {
  setIsSaved(state, value) {
    state.isSaved = value;
  },
};


// WEBPACK FOOTER //
// ./src/modules/bids/vuex/mutations.js